import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c5145ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog" }
const _hoisted_2 = { class: "dialog-title" }
const _hoisted_3 = { class: "title" }

import { watch } from "vue";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean },
    title: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:modelValue", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: boolean;
  title: string;
}

const { t } = useI18n();


const close = () => {
  emit("update:modelValue", false);
};
const onClickBackground = (e: MouseEvent) => {
  if (e.target instanceof HTMLElement && e.target.className === "background") {
    close();
  }
};
let isRegistered = false;
const onKeydown = (e: KeyboardEvent) => {
  if (e.key === "Escape") {
    close();
  }
};
watch(props, () => {
  if (props.modelValue && !isRegistered) {
    window.addEventListener("keydown", onKeydown);
    isRegistered = true;
  } else if (!props.modelValue && isRegistered) {
    window.removeEventListener("keydown", onKeydown);
    isRegistered = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (__props.modelValue)
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: ".app"
      }, [
        _createElementVNode("div", {
          class: "background",
          onClick: onClickBackground
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)(__props.title)), 1),
              _createElementVNode("h1", { onClick: close }, [
                _createVNode(_component_font_awesome_icon, { icon: "close" })
              ])
            ]),
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})